<section class="instructions">
    <div class="how-it-works-images">
        <div class="grid-item" *ngFor="let image of imagesPart3; let i = index">
            <img [src]="'assets/layout/images/home/part_3/' + image.filename" alt="Image {{ i }}" />
        </div>
    </div>
    <div class="how-it-works-content">
        <h1>¿Cómo Funciona?</h1>
        <ol>
            <li>Tadic List es una plataforma diferente. No tenemos intermediarios.</li>
            <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
            <li>Lorem Ipsum has been the industry's standard dummy.</li>
        </ol>
        <button pButton pRipple type="button" class="cta-button">
            <span class="px-4">Explorar planes</span>
            <i class="pi pi-arrow-right custom-arrow-right-icon"></i>
        </button>
    </div>
</section>
